import { ItemObject } from 'src/app/models/orders/item/item-object.model';
import { Converter } from '../converter.interface';
import { Injectable } from '@angular/core';
import { TabObject } from 'src/app/models/orders/item/tab-object.model';
import { TreeCardObject } from 'src/app/models/orders/tree-card/tree-card-object.model';

@Injectable({
    providedIn: 'root'
})
export class OrderItemConverter implements Converter<ItemObject>{

    constructor() { }

    convert(input: TreeCardObject): ItemObject {
        return new ItemObject(input.getCrmId(), input.getOrderId(), input.getType(), TabObject.GENERAL_TAB);
    }
}